import React, {useState, useEffect} from 'react'

const ImageWrapper = ({src, alt, className=''}) => {
    const [imageStatus, setImageStatus] = useState('loading')
    const [brokenImages, setBrokenImages] = useState(new Set())

    useEffect(() => {
        if (!src || !isImageUrl(src)) {
            setImageStatus('error')
        }
    }, [src])

    const handleImageError = (imageUrl) => {
        setBrokenImages(prev => new Set(prev).add(imageUrl))
    }

    const isImageUrl = (url) => {
        if (!url) return false
        const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg']
        const lowerUrl = url.toLowerCase()
        return imageExtensions.some(ext => lowerUrl.includes(ext)) || 
               lowerUrl.startsWith('http') && (lowerUrl.includes('image') || lowerUrl.includes('img'))
    }

    // Jika tidak ada URL atau bukan URL gambar
    if (!src || !isImageUrl(src)) {
        return (
            <div
                style={{
                    width: '80px',
                    height: '60px',
                    backgroundColor: '#f8f9fa',
                    border: '1px solid #ddd',
                    borderRadius: '4px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '12px',
                    color: '#6c757d'
                }}
            >
                No Image
            </div>
        )
    }

    // Jika gambar sudah diketahui rusak, tampilkan placeholder
    if (brokenImages.has(src)) {
        return (
            <div
                style={{
                    width: '80px',
                    height: '60px',
                    backgroundColor: '#f8f9fa',
                    border: '1px solid #ddd',
                    borderRadius: '4px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '12px',
                    color: '#6c757d'
                }}
            >
                Not Found
            </div>
        )
    }

    // Selalu coba tampilkan gambar, biarkan onError menangani kegagalan
    return (
        <img
            src={src}
            alt={alt}
            style={{
                width: '80px',
                height: '60px',
                objectFit: 'contain',
                borderRadius: '4px',
                border: '1px solid #ddd',
            }}
            onError={() => handleImageError(src)}
            // Tidak perlu menangani onLoad karena kita tidak lagi menggunakan imageStatus
        />
    )
}

export default ImageWrapper